import { render, staticRenderFns } from "./BidderInfoModal.vue?vue&type=template&id=7b5dccfa&scoped=true"
import script from "./BidderInfoModal.vue?vue&type=script&lang=js"
export * from "./BidderInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5dccfa",
  null
  
)

export default component.exports